import {
  CASE_CREATION,
  CLEAR_FORM,
  SET_AM_FORM_DATA,
  SET_PM_FORM_DATA,
  UPDATE_AM_CASE_FIELD,
  UPDATE_PM_CASE_FIELD,
} from "../actions/caseAction";

const initialState = {
  pmCase: {
    subjectInformation: {
      temporary_identifier: "",
      nationality: "",
      date_of_accident: "",
      type_of_accident: "",
      accident_description: "",
      location_of_recovery: "",
    },
    clinicalInformation: {
      gender: "",
      // status: "",
      ethnicity: "",
      estimated_age_from_year: "",
      estimated_age_from_month: "",

      estimated_age_to_year: "",
      estimated_age_to_month: "",
      medical_history: "",
      // identifying_marks: "",
    },
  },
  amCase: {
    subjectInformation: {
      full_name: "",
      nationality: "",
      dob: "",
      age_years: "",
      identity_type: "",
      identity_code: "",
      // referring_agency: "",
      source_of_records: "",
      date_of_records: "",
    },
    clinicalInformation: {
      gender: "",
      // status: "",
      ethnicity: "",
      medical_history: "",
      // identifying_marks: "",
    },
  },
};

export default function caseReducer(state = initialState, action) {
  switch (action.type) {
    case CASE_CREATION:
      return {
        ...state,
        ...action.payload, // Use this to set initial data if needed
      };
      break;

    case UPDATE_PM_CASE_FIELD:
      const {
        section: pmSection,
        field: pmField,
        value: pmValue,
      } = action.payload;
      return {
        ...state,
        pmCase: {
          ...state.pmCase,
          [pmSection]: {
            ...state.pmCase[pmSection],
            [pmField]: pmValue,
          },
        },
      };

    case UPDATE_AM_CASE_FIELD:
      const {
        section: amSection,
        field: amField,
        value: amValue,
      } = action.payload;
      return {
        ...state,
        amCase: {
          ...state.amCase,
          [amSection]: {
            ...state.amCase[amSection],
            [amField]: amValue,
          },
        },
      };

      break;

    case CLEAR_FORM:
      return {
        ...initialState,
      };
      break;

    case SET_PM_FORM_DATA:
      const caseData = action.payload;

      // Split estimated_age_from and estimated_age_to into years and months
      const splitAge = (age) => {
        const ageFloat = parseFloat(age);
        const year = Math.floor(ageFloat);
        const month = Math.round((ageFloat - year) * 12);
        return {
          year: isNaN(year) ? "" : year,
          month: isNaN(month) ? "" : month,
        };
      };

      // Split the age data into years and months
      const { year: estimatedAgeFromYear, month: estimatedAgeFromMonth } =
        splitAge(caseData?.estimated_age_from || "0");
      const { year: estimatedAgeToYear, month: estimatedAgeToMonth } = splitAge(
        caseData?.estimated_age_to || "0"
      );
      return {
        ...state,
        pmCase: {
          subjectInformation: {
            temporary_identifier: caseData?.temporary_identifier || "",
            nationality: caseData?.nationality?.id || null,
            date_of_accident: caseData?.date_of_accident || "",
            type_of_accident: caseData?.type_of_accident || "",
            location_of_recovery: caseData?.location_of_recovery || "",
            accident_description: caseData?.accident_description || "",
          },
          clinicalInformation: {
            gender: caseData?.gender || "",
            // status: caseData?.status || "",
            ethnicity: caseData?.ethnicity || "",
            estimated_age_from_year: estimatedAgeFromYear,
            estimated_age_from_month: estimatedAgeFromMonth,
            estimated_age_to_year: estimatedAgeToYear,
            estimated_age_to_month: estimatedAgeToMonth,
            medical_history: caseData?.medical_history || "",
            // identifying_marks: caseData?.identifying_marks || "",
          },
        },
      };
      break;

    case SET_AM_FORM_DATA:
      const amCaseData = action.payload;

      // Return updated state
      return {
        ...state,
        amCase: {
          subjectInformation: {
            full_name: amCaseData.full_name || "",
            nationality: amCaseData.nationality?.id || "",
            dob: amCaseData.dob || "",
            age_years: amCaseData?.age_years || "",
            identity_type: amCaseData?.identity_type || "",
            identity_code: amCaseData?.identity_code || "",
            // referring_agency: amCaseData?.referring_agency || "",
            source_of_records: amCaseData?.source_of_records || "",
            date_of_records: amCaseData?.date_of_records || "",
          },
          clinicalInformation: {
            gender: amCaseData.gender || "",
            // status: amCaseData.status || "",
            ethnicity: amCaseData.ethnicity || "",
            medical_history: amCaseData.medical_history || "",
            // identifying_marks: amCaseData.identifying_marks || "",
          },
        },
      };
      break;

    default:
      return state;
  }
}
